import Immutable from 'immutable';

import {createRepo} from '../services/repo';
import {SET_CURRENT_TEST, START_TEST, STOP_TEST} from '../actions/tests';
import {OPTIMISTICALLY_MARK_TEST_AS_COMPLETE} from '../actions/testroom';

const testsRepo = createRepo({
  modelName: 'test',
  plural: 'tests',
  isGlobal: true,
  getCurrentTest,
});

const {TESTS_LOADING_SUCCESS, TEST_LOADING_SUCCESS} = testsRepo.actions;
const {handleTestsLoading, handleTestLoading} = testsRepo.reducers;

const initialState = testsRepo.getInitialState({
  current: {},
  testing: {},
  completed: 0,
});

export default function(state = initialState, action) {
  switch (action.type) {
    case TESTS_LOADING_SUCCESS:
      return handleTestsLoading(state, action);
    case TEST_LOADING_SUCCESS:
      return handleTestLoading(state, action);
    case SET_CURRENT_TEST:
      return state.merge({current: Immutable.fromJS(action.data), testing: {}});
    case START_TEST:
      return state.set('testing', state.getIn(['current']));
    case STOP_TEST:
      return state.merge({
        current: {},
        testing: {},
      });
    case OPTIMISTICALLY_MARK_TEST_AS_COMPLETE:
      return handleMarkTestAsComplete(state, action);
    default:
      return state;
  }
}

function handleMarkTestAsComplete(state, action) {
  const index = state.get('list').findIndex(t => t.get('id') === action.testId);
  if (index === -1) {
    return state;
  }

  return state.updateIn(['list', index], t => t.set('status', 'complete'));
}

/* Selectors */

export const {getTests: _getTests, getTestById, getTestsSelection} = testsRepo.selectors;

export function getTests(state) {
  return _getTests(state).sort((a, b) => {
    if (a.get('position') === b.get('position')) {
      return a.get('id') - b.get('id');
    }

    return a.get('position') - b.get('position');
  });
}

export function getCurrentTest(state) {
  return state.getIn(['tests', 'current']);
}

export function getCompletedTest(state) {
  return state.getIn(['tests', 'list']).filter(item => item.get('status') === 'complete');
}

export function getIsTesting(state) {
  return state.getIn(['tests', 'testing']);
}
